<template>
  <DateRangeColumn
    :start-date="column.startDate"
    :end-date="column.endDate"
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import DateRangeColumn from '@/components/GraphqlDataTable/columns/DateRangeColumn.vue'

const PaymentRequestTimesheetPeriodColumn = graphql(`
  fragment PaymentRequestTimesheetPeriodColumn on PaymentRequest {
    id
    startDate
    endDate
  }
`)

const props = defineProps<{
  row: FragmentType<typeof PaymentRequestTimesheetPeriodColumn>
}>()

const column = computed(() => useFragment(PaymentRequestTimesheetPeriodColumn, props.row))
</script>

<style scoped></style>
